module.exports = __webpack_public_path__ + "img/img_notice_pop_main_02.4af0a69f.png";